import {
    find,
    flatten,
    mapValues,
    pick as lodashPick,
    sortBy,
    uniq,
    value,
    values,
    size,
} from 'lodash-es'

export function pick(object, properties) {
    return properties.reduce((pickedObject, property) => {
        pickedObject[property] = object[property]
        return pickedObject
    }, {})
}

const chainableFunctions = {
    sortBy,
    find,
    value,
    values,
    pick: lodashPick,
    flatten,
    uniq,
    size,
}

// See https://github.com/lodash/lodash/issues/3298#issuecomment-341685354
export const chain = (input) => {
    let value = input
    const wrapper = {
        ...mapValues(chainableFunctions, (f) => (...args) => {
            value = f(value, ...args)
            return wrapper
        }),
        value: () => value,
    }
    return wrapper
}
